import React from 'react'
import styled from 'styled-components'
import { line, radius, font, surface } from 'features/dashboard/tokens'

// items: [{ key, label, count, tint, sub? , onClick? }]
const RagBreakdown = ({ items = [], emptyLabel = 'Nothing to show in this view yet.' }) => {
  const rows = (items || []).filter(Boolean)
  const total = rows.reduce((s, r) => s + (r.count || 0), 0)

  if (total === 0) {
    return <Empty>{emptyLabel}</Empty>
  }

  return (
    <Wrap>
      <Bar>
        {rows.map(r => (r.count > 0
          ? <Seg key={r.key} style={{ width: `${(r.count / total) * 100}%`, background: r.tint }} title={`${r.label}: ${r.count}`} />
          : null))}
      </Bar>
      <List>
        {rows.map(r => (
          <Row
            key={r.key}
            $clickable={!!r.onClick}
            onClick={r.onClick || undefined}
            title={r.onClick ? `Open ${r.label}` : undefined}
          >
            <Dot style={{ background: r.tint }} />
            <RowLabel>{r.label}</RowLabel>
            {r.sub ? <RowSub>{r.sub}</RowSub> : null}
            <RowCount>{r.count || 0}</RowCount>
          </Row>
        ))}
      </List>
    </Wrap>
  )
}

export default RagBreakdown

const Wrap = styled.div`
  display: flex; flex-direction: column; gap: 12px;
`

const Bar = styled.div`
  display: flex;
  height: 10px;
  border-radius: ${radius.pill};
  overflow: hidden;
  background: ${surface.wash};
  border: 1px solid ${line.base};
`

const Seg = styled.div` height: 100%; `

const List = styled.div`
  display: flex; flex-direction: column;
`

const Row = styled.div`
  display: flex; align-items: center; gap: 10px;
  padding: 8px 4px;
  border-bottom: 1px solid ${surface.wash};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  &:hover { background: ${({ $clickable }) => ($clickable ? surface.wash : 'transparent')}; }
  &:last-child { border-bottom: none; }
`

const Dot = styled.span`
  width: 10px; height: 10px; border-radius: 3px; flex: 0 0 auto;
`

const RowLabel = styled.span`
  flex: 1; min-width: 0;
  font-size: ${font.body};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.haiti};
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
`

const RowSub = styled.span`
  font-size: ${font.caption};
  color: ${({ theme }) => theme.colors.grey[800]};
  white-space: nowrap;
`

const RowCount = styled.span`
  font-size: ${font.emphasis};
  font-weight: 800;
  color: ${({ theme }) => theme.colors.haiti};
  font-variant-numeric: tabular-nums;
  min-width: 24px; text-align: right;
`

const Empty = styled.div`
  padding: 24px; text-align: center;
  color: ${({ theme }) => theme.colors.grey[800]};
  font-size: ${font.body};
  background: ${({ theme }) => theme.colors.lighterGrey};
  border: 1px dashed ${line.base};
  border-radius: ${radius.md};
`
